/* eslint-disable react-hooks/exhaustive-deps */
import styles from "./VoiceCallButton.module.css"
import {ReactComponent as DialerIcon} from "./dialer.svg"
import {Auth} from "types/auth"
import {useCallback, useContext, useMemo} from "react"
import {VoiceCallContext} from "context/VoiceCallContext"
import {getFullName, toastInfo} from "helpers"
import cx from "classnames"
import {DialerStudent} from "types/auto-dialer"
import {getDefaultOrFirstProfile} from "helpers/task"
import {Settings} from "types/settings"

type Props = {
    dialerId?: number
    studentProfileId?: number
    studentData?: Auth.UserProfile
    departmentId?: number
}

export function VoiceCallButton({dialerId, studentData, departmentId, studentProfileId}: Props) {
    const {calling, startCall, onEndedCallback, voiceProvider} = useContext(VoiceCallContext)
    // Zoom does not send a reliable end signal (and NAU hides the panel), so `calling` can stay true.
    const isCallLocked = calling && voiceProvider !== Settings.DialerProvider.Zoom

    const phone = useMemo(() => {
        const primaryPhone = studentData?.phones.filter((p) => p.isPrimary)[0]?.corrected_phone
        return primaryPhone || studentData?.phones[0]?.corrected_phone
    }, [studentData.phones])
    const email = useMemo(() => studentData?.emails.filter((e) => e.isPrimary)[0]?.email, [studentData.emails])
    const profile = studentProfileId
        ? (studentData?.profiles || []).find((p) => p.id === studentProfileId)
        : getDefaultOrFirstProfile(studentData, Auth.UserProfileType.Student)
    const studentInfo: DialerStudent = {
        userId: studentData?.id,
        profileId: studentProfileId,
        fullName: getFullName(studentData),
        email,
        phone,
        campusName: profile?.campus,
        campusId: profile?.campuses?.[0]?.id,
        dialerId
    }

    const handleStartCall = useCallback(() => {
        if (isCallLocked) return
        if (!studentInfo.phone) {
            return toastInfo("This student has no phone number")
        }
        startCall(studentInfo, departmentId)
        onEndedCallback(null)
    }, [isCallLocked, studentInfo, departmentId, startCall])

    return (
        <div className={cx(styles.btnWrap, {[styles.disabled]: isCallLocked})} onClick={handleStartCall}>
            <DialerIcon className={styles.icon} />
            <span className={styles.title}>Voice Call</span>
        </div>
    )
}
